import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseInterface, LoginInterface, RegisterInterface } from '../interface/auth';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  /**
   * Signs up
   * @param params
   * @returns
   */
  public signUp(params: RegisterInterface): Observable<ApiResponseInterface> {
    return this.http.post(`${environment.API_BASE_URL}user/auth/register`, params).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      }),
    );
  }

  /**
   * Signs in
   * @param params
   * @returns
   */
  public signIn(params: LoginInterface): Observable<ApiResponseInterface> {
    return this.http.post<ApiResponseInterface>(`${environment.API_BASE_URL}user/auth/login`, params).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      }),
    );
  }


  /**
   * Sends a request to the server to initiate a password reset process for the given email.
   *
   * @param email - The email address for which the password reset is requested.
   * @returns Observable<ApiResponseInterface> - The API response indicating the result of the request.
   */

  public forgotPassword(email: string): Observable<ApiResponseInterface> {
    return this.http.post<ApiResponseInterface>(`${environment.API_BASE_URL}user/auth/forgot-password`, { email }).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      })
    )
  }

  /**
   * Verifies the OTP entered by the user with the server.
   *
   * @param otp - The one-time password to be verified.
   * @param email - The email address associated with the OTP.
   * @returns Observable<ApiResponseInterface> - The API response indicating the result of the verification.
   */
  public verifyOtp(otp: number, email: string): Observable<ApiResponseInterface> {
    return this.http.post<ApiResponseInterface>(`${environment.API_BASE_URL}user/auth/validate-otp`, { otp, email }).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      })
    )
  }

  /**
   * Resets new password
   * @param password New password
   * @param email Email sent during forgot password
   * @param otp OTP sent during forgot password
   * @returns Response from server
   */
  public resetNewPassword(password: string, email: string, otp: number): Observable<ApiResponseInterface> {
    return this.http.post<ApiResponseInterface>(`${environment.API_BASE_URL}user/auth/reset-password`, { email, otp, password }).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      })
    )
  }

  /**
   * Verifies the email address associated with the given OTP.
   *
   * @param otp - The one-time password to be verified.
   * @returns Observable<ApiResponseInterface> - The API response indicating the result of the verification.
   */
  public verifyEmailByOtp(otp: number): Observable<ApiResponseInterface> {
    return this.http.post<ApiResponseInterface>(`${environment.API_BASE_URL}user/auth/email/verify`, { otp }).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      })
    )
  }

}
